<app-input-search [allowNavigation]="true" placeholderInput="Найдите клиента" [options]="customers" (searchChange)="searchCustomers($event)"></app-input-search>